// extracted by mini-css-extract-plugin
export default {"past":"index_past_Kj12U","pastH":"index_pastH_pY3Ty","passItem":"index_passItem_u6BA0"};